import { useState } from 'react';
import "./Footer.css";

const Footer = () => {
  // Состояние для попапа (опционально, если нужна интерактивность)
  const [showPopup, setShowPopup] = useState(false);

  const handlePercentClick = () => {
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 4000); // Закрыть через * секунды
  };

  return (
    <div id="footer">
      <div className="footer">
        <div className="unten">
        </div>
        <div className="ilike">
          <button
            className="ilike_but_top"
            onClick={handlePercentClick}
            aria-label="Информация о прогрессе издания"
          >
            Издание книги «Сын Люцифера»
          </button>
          {showPopup && (
            <div className="percent-popup">
              <p>Текущий прогресс: 18 %</p>
            </div>
          )}
        </div>
        <div className="copy">
        </div>
      </div>
    </div>
  );
};

export default Footer;